import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/vaga`;

export const cadastrarVaga = (data) => {
	return api.post(BASE_URL, data);
};

export const editarVaga = (id, data) => {
	return api.put(`${BASE_URL}/${id}`, data);
};

export const cancelarVaga = (id, data) => {
	return api.post(`${BASE_URL}/${id}/cancelamento-vaga`, data);
};

export const buscarVaga = (id) => {
	return api.get(`${BASE_URL}/${id}`);
};

export const excluirVaga = (id) => {
	return api.delete(`${BASE_URL}/${id}`);
};

export const consultarVagas = (params, filtros) => {
	return api.get(`${BASE_URL}/resumo-vaga/paginado`, { params: { ...params, ...filtros } });
};

export const analisarVaga = (id) => {
	return api.post(`${BASE_URL}/${id}/analise`);
};

export const reaproveitarVaga = (id) => {
	return api.post(`${BASE_URL}/${id}/reaproveitamento`);
};

export const buscarSituacoesPossiveis = (id, params) => {
	return api.get(`${BASE_URL}/${id}/situacoes-possiveis`, { params: { ...params, } });
};
